export default __webpack_public_path__ + "static/7-Accessories-to-Make-Travelling-Easier-92ed2d7a4c055c11818248b3253d70d9.jpg";